import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";

export const validateLedgerTemplateAction = async (file) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const response = await apiClient.post(
      ATP_API_URL.VALIDATE_LEDGER_TEMPLATE,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } },
    );

    if (response?.status === 200 && response.data) {
      const { success, data, message } = response.data;
      if (success) {
        return { success: true, data: data || [], message };
      }
      return {
        success: false,
        message: message || "Validation failed",
        data: [],
      };
    }

    return { success: false, message: "Validation failed", data: [] };
  } catch (error) {
    console.error("[ValidateLedger] error:", error);
    return {
      success: false,
      message: error.message || "Failed to validate template",
      data: [],
    };
  }
};
